<template>
    <div class="main-content">
        <section class="setting-profile-popup mfp-hide popup-save-document" style="z-index: 10">
            <a @click="$router.go(-1)" class="profile-edit-close-btn">
                <img src="/assets/img/close-icon.svg"/>
            </a>
            <div class="setting-profile-wrapper">
                <div class="save-document-form">
                    <h2>Do you want to switch to your Personal Space?</h2>
                    <button class="btn btn-primary mr-0 mt-3 mx-auto" @click="switchNormalSpace()">YES, LET'S GO!</button>
                    <div style="display:block;" class="mt-3">
                        <router-link :to="{ path: '/apps' }" class="mx-auto underlined-link">No Wait, I didn't want to do that!</router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApiService from "../../api/api.service";

export default {
    name: "SwitchToPersonalSpace",
    methods: {
        switchNormalSpace() {
            ApiService.setHeader();
            ApiService.post('/api/teams/switch-normal')
                .then(({data}) => {
                    this.activeTeam = false;
                    ApiService.setHeader();
                    ApiService.get('/api/user').then(({data}) => {
                        this.user = data;
                        window.localStorage.setItem('user', JSON.stringify(data));

                        this.$router.push({ name: 'Apps Center'});
                    }).catch(error => {
                        throw new Error('failed to load user');
                    });

                })
                .catch();
        }
    }
}
</script>

<style scoped>

</style>
